import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { translateStaticContent } from '../../../helpers/translateStaticContent';

const CalculationResult = (props) => {
    let isShowMinCommission = null;
    if (props.result.commissionValueByInput) {
        isShowMinCommission = props.result.minCommissionAmountInToCcy > props.result.commissionValueByInput ? '' : 'none';
    } else {
        isShowMinCommission = props.result.minCommissionAmountInToCcy  ? '' : 'none';
    }
    const isShowCommission = props.result.commissionPercent ? '' : 'none';

    const handleClick = () => {
        props.scroll();
    }
    const direction = getDirection(props.countryFromISO, props.countryToISO);
    return(
        <div className="calculation-result">
            <div className="radius"></div>
            <div className="value-rate">
                <div className="value-rate-item">
                    <div className="label">
                        {translateStaticContent('transferSum', 
                            props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
                    </div>
                    <div className="values">
                        <span className="value">{props.result.amountInput}</span>
                        &nbsp;
                        <span className="currency">{props.result.fromCurrencySelected}</span>
                    </div>
                </div>
                <div className={`value-rate-item ${isShowCommission}`}>
                    <div className="label">
                        {translateStaticContent('commission', 
                            props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}&nbsp;
                    {props.result.commissionPercent}%</div>
                    <div className="values">
                        <span className="value">{props.result.commissionValue}</span>
                        &nbsp;
                        <span className="currency">{props.result.fromCurrencySelected}</span>
                    </div>
                </div>  
                <div className={`value-rate-item ${isShowMinCommission}`}>
                    <div className="label">
                        {translateStaticContent('minCommission', 
                            props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
                    </div>
                    <div className="values">
                        <span className="value">{props.result.minCommissionAmountInToCcy}</span>
                        &nbsp;
                        <span className="currency">{props.result.fromCurrencySelected}</span>
                    </div>
                </div> 
                <div className="value-rate-item">
                    <div className="label">
                        {translateStaticContent('totalTransferSum', 
                            props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
                    </div>
                    <div className="values">
                        <span className="value">{props.result.allValueAmount}</span>
                        &nbsp;
                        <span className="currency">{props.result.fromCurrencySelected}</span>
                    </div>
                </div>   
            </div>
            <div className="value-result">
                <div className="label">
                    {translateStaticContent('transferSumForRecipient', 
                        props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
                </div>
                <div className="values">
                    <span className="value">{props.result.amountInput}</span>
                    &nbsp;
                    <span className="currency">{props.result.toCurrencySelected}</span>
                </div>
            </div>
            <p>{translateStaticContent('tariffInfoText', 
                    props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
            </p>
            <p><NavLink to={{
                pathname: '/tariffs',
                state: direction,
                }} className='link' rel="noreferrer">
                {translateStaticContent('tariffInfoBtn', 
                    props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
            </NavLink>.</p>
            <button className="btn" onClick={handleClick}>
                {translateStaticContent('transferCounBtn', 
                    props.defaultStaticContentCalc, props.activeLangStaticContentCalc)}
            </button>
        </div>
    )
}

export default CalculationResult;

CalculationResult.propTypes = {
    result: PropTypes.object.isRequired,
    scroll: PropTypes.func.isRequired,
    defaultStaticContentCalc: PropTypes.object,
    activeLangStaticContentCalc: PropTypes.object,
    countryFromISO: PropTypes.string.isRequired,
    countryToISO: PropTypes.string.isRequired
}

const getDirection = (from, to) => {
    const dir = {
        from,
        to
    }
    let direction = '';
    switch (true) {
        case (dir.from === 'UKR' && dir.to === 'UKR'): {
            direction = 'domestic';
            break;
        }
        case (dir.from === 'UKR' && dir.to !== 'UKR'): {
            direction = 'outbound';
            break;
        }
        case (dir.from !== 'UKR' && dir.to === 'UKR'): {
            direction = 'inbound';
            break;
        }
    }
    return direction;
}